import { render, staticRenderFns } from "./salesareatable.vue?vue&type=template&id=d1fe7ef6&scoped=true&"
import script from "./salesareatable.vue?vue&type=script&lang=js&"
export * from "./salesareatable.vue?vue&type=script&lang=js&"
import style0 from "./salesareatable.vue?vue&type=style&index=0&id=d1fe7ef6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fe7ef6",
  null
  
)

export default component.exports